<app-vis-dialog [title]="title" [show]="show" (close)="closeDialog()" (open)="onDialogOpen()"
  [width]="0" [superWidth]="'80%'" [height]="'80%'" [maxWidth]="'90vw'">
  <div class="p-2">
    <!-- 篩選區 -->
    <form [formGroup]="queryFormGroup" class="mb-2">
      <!-- 第一排: 商品名稱 / 廠商 / 歸屬類別 -->
      <div class="filter-row mb-1">
        <label class="c-form-field d-inline-flex">
          <span>商品名稱</span>
          <input class="vis-input ml-1" formControlName="productName" style="width: 150px;" (keyup.enter)="onBtnQueryClick()"/>
        </label>
        <label class="c-form-field d-inline-flex">
          <span>廠商</span>
          <app-vis-combobox formControlName="vendorCode" style="width: 200px;" [valueFormat]="'valuetext'"
            [data]="vendorOptions" class="ml-1 query-input-vendor">
          </app-vis-combobox>
        </label>
        <label class="c-form-field d-inline-flex">
          <span>歸屬類別</span>
          <app-vis-dropdownlist formControlName="rxType"
            [data]="editOptions.rxTypes"
            [valueField]="'value'"
            [textField]="'text'"
            class="ml-1 no-extend"
            [valuePrimitive]="true"
            [tabIndex]="3">
          </app-vis-dropdownlist>
        </label>
      </div>
      <!-- 第二排: 貨號 / 貨號(起) / 貨號(迄) / 查詢 / 全選 / 全取消 -->
      <div class="filter-row">
        <label class="c-form-field d-inline-flex">
          <span style="display: inline-block; width: 4em; text-align: justify; text-align-last: justify;">貨號</span>
          <input class="vis-input ml-1" formControlName="productCode" style="width: 100px;" (keyup.enter)="onBtnQueryClick()"/>
        </label>
        <label class="c-form-field d-inline-flex">
          <span>貨號(起)</span>
          <input class="vis-input ml-1" formControlName="productCodeStart" style="width: 100px;" (keyup.enter)="onBtnQueryClick()"/>
        </label>
        <label class="c-form-field d-inline-flex">
          <span>貨號(迄)</span>
          <input class="vis-input ml-1" formControlName="productCodeEnd" style="width: 100px;" (keyup.enter)="onBtnQueryClick()"/>
        </label>
        <button type="button"
          (click)="onBtnQueryClick()"
          class="vis-btn-config p-0 position-relative pl-2 w-18 ml-2"
          title="查詢"
          tabindex="6">
          <mat-icon class="pref-icon vis-combine-icon">search</mat-icon>
          <span class="position-absolute text-xs-sm start-0 ml-4 pl-2">查詢</span>
        </button>
        <div class="query-btn">
          <button type="button"
            (click)="selectAll()"
            [disabled]="!listItems || listItems.length === 0"
            class="vis-btn-config p-0 position-relative pl-2 w-18 ml-1"
            title="全選">
            <mat-icon class="pref-icon vis-combine-icon" style="color: green;">select_all</mat-icon>
            <span class="position-absolute text-xs-sm start-0 ml-4 pl-2">全選</span>
          </button>
          <button type="button"
            (click)="deselectAll()"
            [disabled]="!selectedItems || selectedItems.length === 0"
            class="vis-btn-config p-0 position-relative pl-2 w-22 ml-1"
            title="全取消">
            <mat-icon class="pref-icon vis-combine-icon" style="color: red;">deselect</mat-icon>
            <span class="position-absolute text-xs-sm start-0 ml-4 pl-2">全取消</span>
          </button>
        </div>
      </div>
    </form>

    <!-- 商品清單表格 -->
    <app-vis-grid [data]="gridView"
      [pageSize]="pageSize"
      [skip]="pageSkipNo"
      [pageable]="true"
      (pageChange)="pageChange($event)"
      [selectable]="true"
      [multiselect]="true"
      [selectByCheckOnly]="true"
      [kendoGridSelectBy]="'Id'"
      [selectedKeys]="selectedItems"
      [keepSelectionOnPageChange]="true"
      class="no-border batch-add-grid">
      <!-- Checkbox 欄位 -->
      <app-vis-grid-checkbox-column
        [showSelectAll]="true"
        [width]="50"
        [setDisable]="!enableStockSystem"
        [checkOnSelect]="true"
        [allChecked]="isCurrentPageAllChecked"
        [someChecked]="isCurrentPageSomeChecked"
        (checkChanged)="checkChanged($event)">
      </app-vis-grid-checkbox-column>
      <!-- 貨號 -->
      <app-vis-grid-column field="ProductCode" title="貨號" [width]="120">
      </app-vis-grid-column>
      <!-- 商品名稱 -->
      <app-vis-grid-column field="ProductName" title="商品名稱" class="custom-name">
        <ng-template let-data>
          <div class="ellipsis-content" [title]="data.ProductName">
            <app-stocks-product-tags [product]="data"></app-stocks-product-tags>
            {{ data.ProductName }}
          </div>
        </ng-template>
      </app-vis-grid-column>
      <!-- 廠商代碼 -->
      <app-vis-grid-column field="VendorCode" title="廠商代碼" [width]="100">
      </app-vis-grid-column>
      <!-- 廠商 -->
      <app-vis-grid-column field="VendorName" title="廠商" [width]="350">
        <ng-template let-data>
          <div class="ellipsis-content" [title]="data.VendorName">{{ data.VendorName }}</div>
        </ng-template>
      </app-vis-grid-column>
      <!-- 單位 -->
      <app-vis-grid-column field="Unit" title="單位" [width]="80">
      </app-vis-grid-column>
    </app-vis-grid>
  </div>
  <app-vis-dialog-actions>
    <button type="button" (click)="confirmAdd()" [disabled]="getSelectedCount() === 0">新增 ({{ getSelectedCount() }})</button>
    <button type="button" (click)="closeDialog()">取消</button>
  </app-vis-dialog-actions>
</app-vis-dialog>
